/* eslint-env browser */

(function (window) {
    'use strict';

    var SEARCH_DEBOUNCE_MS = 350;
    var DEFAULT_CENTER = [12.4964, 41.9028];
    var DEFAULT_ZOOM = 5;
    var SELECTED_ZOOM = 11;

    function debounce(fn, wait) {
        var timer;
        return function () {
            var args = arguments;
            var ctx = this;
            window.clearTimeout(timer);
            timer = window.setTimeout(function () {
                fn.apply(ctx, args);
            }, wait);
        };
    }

    function formatPlaceLabel(props) {
        if (!props) {
            return '';
        }
        var parts = [];
        if (props.name && props.name !== props.city && props.name !== props.state) {
            parts.push(props.name);
        }
        if (props.city) {
            parts.push(props.city);
        } else if (props.state) {
            parts.push(props.state);
        }
        if (props.country) {
            parts.push(props.country);
        }
        return parts.join(', ');
    }

    function fetchTimezone(lat, lon) {
        return fetch(
            'https://api.bigdatacloud.net/data/timezone-by-location?latitude='
            + encodeURIComponent(lat) + '&longitude=' + encodeURIComponent(lon)
        )
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('timezone lookup failed');
                }
                return res.json();
            })
            .then(function (data) {
                return data.ianaTimeId || 'Europe/Rome';
            })
            .catch(function () {
                return 'Europe/Rome';
            });
    }

    function reversePlace(lat, lon) {
        return fetch(
            'https://photon.komoot.io/reverse?lat='
            + encodeURIComponent(lat) + '&lon=' + encodeURIComponent(lon)
        )
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('reverse geocode failed');
                }
                return res.json();
            })
            .then(function (data) {
                var feature = data && data.features && data.features[0];
                if (!feature) {
                    return null;
                }
                return {
                    label: formatPlaceLabel(feature.properties) || feature.properties.name || '',
                    coords: feature.geometry.coordinates
                };
            })
            .catch(function () {
                return null;
            });
    }

    function searchPlaces(query) {
        return fetch(
            'https://photon.komoot.io/api/?q='
            + encodeURIComponent(query) + '&limit=6&lat=41.9028&lon=12.4964'
        )
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('search failed');
                }
                return res.json();
            })
            .then(function (data) {
                if (data && Array.isArray(data.features)) {
                    return data.features;
                }
                return [];
            })
            .catch(function () {
                return [];
            });
    }

    function mountPlacePicker(survey, htmlElement) {
        if (!window.maplibregl || !survey || !htmlElement) {
            return;
        }

        var shell = htmlElement.querySelector('[data-siwa-place-picker]');
        if (!shell || shell.dataset.siwaPlaceMounted === '1') {
            return;
        }

        var searchInput = shell.querySelector('[data-siwa-place-search]');
        var resultsEl = shell.querySelector('[data-siwa-place-results]');
        var summaryEl = shell.querySelector('[data-siwa-place-summary]');
        var mapEl = shell.querySelector('[data-siwa-place-map]');

        if (!searchInput || !resultsEl || !summaryEl || !mapEl) {
            return;
        }

        shell.dataset.siwaPlaceMounted = '1';

        var cityQuestion = survey.getQuestionByName('city');
        var latQuestion = survey.getQuestionByName('latitude');
        var lonQuestion = survey.getQuestionByName('longitude');
        var tzQuestion = survey.getQuestionByName('timezone');
        var marker = null;
        var map = null;

        function setSummary(text) {
            summaryEl.textContent = text;
        }

        function syncSurveyFields(label, lng, lat, timezone) {
            if (cityQuestion) {
                cityQuestion.value = label;
            }
            if (latQuestion) {
                latQuestion.value = Math.round(lat * 1000000) / 1000000;
            }
            if (lonQuestion) {
                lonQuestion.value = Math.round(lng * 1000000) / 1000000;
            }
            if (tzQuestion && timezone) {
                tzQuestion.value = timezone;
            }
        }

        function placeMarker(lng, lat) {
            if (!marker) {
                var el = document.createElement('div');
                el.className = 'siwa-place-marker';
                marker = new window.maplibregl.Marker({
                    element: el,
                    draggable: true
                })
                    .setLngLat([lng, lat])
                    .addTo(map);

                marker.on('dragend', function () {
                    var pos = marker.getLngLat();
                    applyCoordinates(pos.lng, pos.lat, null, true);
                });
            } else {
                marker.setLngLat([lng, lat]);
            }
        }

        function applyCoordinates(lng, lat, label, reverseLookup) {
            placeMarker(lng, lat);
            map.flyTo({ center: [lng, lat], zoom: SELECTED_ZOOM, essential: true });

            if (label) {
                setSummary('Selezionato: ' + label);
                fetchTimezone(lat, lng).then(function (timezone) {
                    syncSurveyFields(label, lng, lat, timezone);
                });
                return;
            }

            if (reverseLookup) {
                setSummary('Localizzazione in corso…');
                reversePlace(lat, lng).then(function (place) {
                    var resolvedLabel = (place && place.label)
                        || (lat.toFixed(4) + ', ' + lng.toFixed(4));
                    setSummary('Selezionato: ' + resolvedLabel);
                    fetchTimezone(lat, lng).then(function (timezone) {
                        syncSurveyFields(resolvedLabel, lng, lat, timezone);
                    });
                });
            }
        }

        function hideResults() {
            resultsEl.hidden = true;
            resultsEl.innerHTML = '';
        }

        function showResults(features) {
            if (!features.length) {
                resultsEl.innerHTML = '<li class="siwa-place-picker__result siwa-place-picker__result--empty">Nessun risultato</li>';
                resultsEl.hidden = false;
                return;
            }

            resultsEl.innerHTML = features.map(function (feature, index) {
                var label = formatPlaceLabel(feature.properties) || feature.properties.name || 'Luogo';
                return (
                    '<li class="siwa-place-picker__result" data-result-index="' + index + '">' +
                    label +
                    '</li>'
                );
            }).join('');
            resultsEl.hidden = false;

            resultsEl.querySelectorAll('[data-result-index]').forEach(function (item, index) {
                item.addEventListener('click', function () {
                    var feature = features[index];
                    var coords = feature.geometry.coordinates;
                    var label = formatPlaceLabel(feature.properties) || feature.properties.name || 'Luogo';
                    searchInput.value = label;
                    hideResults();
                    applyCoordinates(coords[0], coords[1], label, false);
                });
            });
        }

        map = new window.maplibregl.Map({
            container: mapEl,
            style: {
                version: 8,
                sources: {
                    cartoVoyager: {
                        type: 'raster',
                        tiles: [
                            'https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
                            'https://b.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png',
                            'https://c.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png'
                        ],
                        tileSize: 256,
                        attribution: '© CARTO © OpenStreetMap contributors'
                    }
                },
                layers: [{
                    id: 'cartoVoyager',
                    type: 'raster',
                    source: 'cartoVoyager'
                }]
            },
            center: DEFAULT_CENTER,
            zoom: DEFAULT_ZOOM,
            attributionControl: false
        });

        map.addControl(new window.maplibregl.NavigationControl({ showCompass: false }), 'top-right');

        var geolocateControl = new window.maplibregl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 60000
            },
            trackUserLocation: false,
            showUserLocation: false,
            showAccuracyCircle: false
        });

        geolocateControl.on('geolocate', function (event) {
            applyCoordinates(event.coords.longitude, event.coords.latitude, null, true);
        });

        geolocateControl.on('error', function () {
            setSummary('Impossibile rilevare la posizione. Cerca manualmente il luogo.');
        });

        map.addControl(geolocateControl, 'top-right');

        map.on('click', function (event) {
            applyCoordinates(event.lngLat.lng, event.lngLat.lat, null, true);
        });

        map.on('load', function () {
            var geolocateButton = mapEl.querySelector('.maplibregl-ctrl-geolocate');
            if (geolocateButton) {
                geolocateButton.setAttribute('title', 'Posizione attuale');
                geolocateButton.setAttribute('aria-label', 'Usa posizione attuale');
            }

            if (latQuestion && lonQuestion && latQuestion.value && lonQuestion.value) {
                var lng = parseFloat(lonQuestion.value);
                var lat = parseFloat(latQuestion.value);
                if (!isNaN(lng) && !isNaN(lat)) {
                    applyCoordinates(lng, lat, cityQuestion && cityQuestion.value, false);
                    return;
                }
            }
            setSummary('Cerca un indirizzo oppure clicca sulla mappa.');
        });

        searchInput.addEventListener('input', debounce(function () {
            var query = searchInput.value.trim();
            if (query.length < 2) {
                hideResults();
                return;
            }
            searchPlaces(query).then(showResults);
        }, SEARCH_DEBOUNCE_MS));

        searchInput.addEventListener('focus', function () {
            if (resultsEl.children.length) {
                resultsEl.hidden = false;
            }
        });

        document.addEventListener('click', function onDocClick(event) {
            if (!shell.contains(event.target)) {
                hideResults();
            }
        });

        shell._siwaPlaceMap = map;
    }

    function setupPlacePicker(survey) {
        survey.onAfterRenderQuestion.add(function (sender, options) {
            if (!options.question || options.question.name !== 'place_picker') {
                return;
            }
            mountPlacePicker(sender, options.htmlElement);
        });

        survey.onAfterRenderPage.add(function (sender, options) {
            if (!options.page || options.page.name !== 'place') {
                return;
            }
            window.setTimeout(function () {
                var question = sender.getQuestionByName('place_picker');
                if (!question || !question.id) {
                    return;
                }
                var htmlElement = document.getElementById(question.id);
                if (htmlElement) {
                    mountPlacePicker(sender, htmlElement);
                }
            }, 50);
        });
    }

    window.SiwaPlacePicker = {
        setup: setupPlacePicker
    };
})(window);
